import axios from 'axios';
import qs from 'qs';

// 查询产品可用优惠券
export function useProductCards(params) {
  return axios({
    url: `/mall/app/coupon/product`,
    method: `get`,
    params,
  });
}
// 分页查询优惠券
export function pageProductCards(params) {
  return axios({
    url: `/mall/app/coupon`,
    method: `get`,
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, {
        indices: false,
      });
    },
  });
}
// 分页查询优惠券可使用的产品简要信息
export function ProductCardsUseList(params) {
  return axios({
    url: `/mall/app/products/coupon`,
    method: `get`,
    params,
  });
}
// 领取优惠券
export function receiveCart(data) {
  return axios({
    url: '/mall/app/coupon/take',
    method: 'post',
    data:data
  });
}
// 查询优惠券面额状态
export function getStatus(params) {
  return axios({
    url: '/mall/app/coupon/status',
    method: 'get',
    params,
    paramsSerializer: params => {
      return qs.stringify(params, {
        indices: false
      })
    }
  })
}
